module.exports = __webpack_public_path__ + "static/media/goods10.c726229e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods10.png
// module id = 435
// module chunks = 0